import { PrebuiltTemplateSummary } from "features/Prebuilt/PrebuiltSharedTemplate/models";
import { SHARED_ROUTES } from "definitions/constants/routeConstants";
import { generatePath } from "../v1";

export function prebuiltEmailTemplatePathById(prebuiltEmailTemplateId: string) {
  return generatePath({ path: SHARED_ROUTES.prebuilt.emailTemplates.show, params: { id: prebuiltEmailTemplateId || "" } });
}

export function prebuiltMessageTemplatePathById(prebuiltMessageTemplateId: string) {
  return generatePath({ path: SHARED_ROUTES.prebuilt.messageTemplates.show, params: { id: prebuiltMessageTemplateId || "" } });
}

export function prebuiltTaskTemplatePathById(prebuiltTaskTemplateId: string) {
  return generatePath({ path: SHARED_ROUTES.prebuilt.taskTemplates.show, params: { id: prebuiltTaskTemplateId || "" } });
}

export function prebuiltTemplatePathByTemplateSummary(template: PrebuiltTemplateSummary) {
  if (!template) {
    return "";
  }
  if (!template?.isPrebuilt) {
    console.log(`Error calling prebuiltTemplatePathByTemplateSummary - Tempplate is not a prebuilt template: ${template?.template?.id}`);
  }

  const prebuitTemplateMap = {
    email_template: (actionTemplate: PrebuiltTemplateSummary) => prebuiltEmailTemplatePathById(actionTemplate?.template?.id),
    task_template: (actionTemplate: PrebuiltTemplateSummary) => prebuiltTaskTemplatePathById(actionTemplate?.template?.id),
    message_template: (actionTemplate: PrebuiltTemplateSummary) => prebuiltMessageTemplatePathById(actionTemplate?.template?.id),
  };

  const getPath = prebuitTemplateMap[template.templateType];
  if (!getPath) throw new Error(`Error calling prebuiltTemplatePathByTemplateSummary - Invalid prebuilt template type: ${template.templateType}`);

  return getPath(template);
}
